import { TooltipDirective } from "@/directives/tooltip/tooltip.directive";
import { ActionService } from "@/services/action.service";
import { AppConfigService } from "@/services/app-config.service";
import { NotificationCheckService } from "@/services/notification-check.service";
import { NgIf } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatBadgeModule } from "@angular/material/badge";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  selector: "app-main-menu-right",
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    MatIconModule,
    MatBadgeModule,
    TooltipDirective,
    MatListModule,
    NgIf,
  ],
  templateUrl: "./main-menu-right.component.html",
  styleUrl: "./main-menu-right.component.scss",
})
export class MainMenuRightComponent implements OnInit, OnDestroy {
  helpPath = "/help";
  notificationsPath = "/notifications";

  showHelp = false;
  notificationsCount = "";
  notificationsTooltipInitial = "Centre de notifications";
  notificationsTooltip = this.notificationsTooltipInitial;

  sub = new Subscription();

  constructor(
    private notificationCheckService: NotificationCheckService,
    private actionService: ActionService,
    private appConfigService: AppConfigService
  ) {}
  ngOnInit(): void {
    this.showHelp = this.appConfigService.isMobileOrTablet;
    this.sub = this.notificationCheckService.notificationCount.subscribe(
      (count) => {
        if (count > 0) {
          this.notificationsCount = "" + count;
          if (count > 1) {
            this.notificationsTooltip =
              count + " nouvelles notifications disponibles";
          } else {
            this.notificationsTooltip = "1 nouvelle notification disponible";
          }
        } else {
          this.notificationsCount = "";
          this.notificationsTooltip = this.notificationsTooltipInitial;
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
